import { Paper } from '@mui/material';
import * as React from 'react';
import DrugDataFormDialog from '../component/drugDatabase/DrugDataFormDialog';
import useDrugDataAdmin from '../component/drugDatabase/DrugDataHook';
import DrugDataListTable from '../component/drugDatabase/DrugDataListTable';
import GroupDrugDataFormDialog from '../component/drugDatabase/GroupDrugDataFormDialog';

interface Props {}

const DrugDatabaseAdminPage: React.FunctionComponent<Props> = (props) => {
  const {
    data,
    isValidating,
    revalidate,
    state: { searchParams, setSearchParams, formDataGroup },
    fnc: {
      setFormDataGroup,
      onDeleteGroup,
      onSubmitFormGroup,
      onSubmitForm,
      refreshMedicationCategoryId,
      setRefreshMedicationCategoryId,
    },
  } = useDrugDataAdmin();

  return (
    <Paper style={{ flex: 1, overflow: 'auto' }}>
      <DrugDataListTable
        loading={isValidating}
        setFormDataGroup={setFormDataGroup}
        onDeleteGroup={onDeleteGroup}
        data={data}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        revalidate={revalidate}
        refreshMedicationCategoryId={refreshMedicationCategoryId}
        setRefreshMedicationCategoryId={setRefreshMedicationCategoryId}
      />

      <GroupDrugDataFormDialog
        open={!!formDataGroup}
        formData={formDataGroup}
        onSubmit={onSubmitFormGroup}
        onClose={() => {
          setFormDataGroup(undefined);
        }}
      />

      <DrugDataFormDialog onSubmit={onSubmitForm} />
    </Paper>
  );
};

export default DrugDatabaseAdminPage;
